module.exports = "/packs/images/home_hero_2~64145e1def9a5673e0632b452c839ef0.webp";